import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Api grid complete component.
 *
 * @author Mikhail Siutsou
 * @function ApiGridComplete
 * @category components
 * @param {GridApiCompleteComponentProps<T>} props grid complete component props.
 * @return {ReactNode} children.
 */
function ApiGridComplete(_ref) {
  var children = _ref.children,
      gridState = _ref.gridState;

  if (gridState) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children(gridState)
    });
  }

  return /*#__PURE__*/_jsx(_Fragment, {});
}

ApiGridComplete.displayName = 'ApiGridComplete';
export { ApiGridComplete };